import * as React from 'react';
import {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  FormHelperText
} from '@mui/material';
import { printVariable } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import useDelegate from "@hooks/useDelegate";
import {styled} from "@mui/material/styles";
import useAlert from "@hooks/useAlert";
import ConfirmDialog from "@components/ConfirmDialog";



const dateFormat = 'YYYY-MM-DD HH:mm:ss';
const FormHelperTexts = styled(FormHelperText)`
    width: 100%;
    padding-left: 16px;
    font-weight: 700 !important;
    color: #d32f2f !important;
  `;

const topicMenu = [
  {name:'전체 관계자', value:'TP01'},
  {name:'전체 학생 보호자', value:'TP04'},
  {name:'전체 강사', value:'TP05'},
  {name:'강좌 관련자', value:'TP06'},
]


const ManagerMessageSmsPartSend = ({dialogHandler, callback}) =>  {


  // redux
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const [smsConfirm, set_smsConfirm] = useState('')
  const [data, set_data] = useState({
    topicMenu: topicMenu[0].value,
    lectureId: 0,
    title:'',
    content:'',
  })

  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()

  const [smst, set_smst] = useState({})
  const [smstList, set_smstList] = useState({})
  const [lectures, set_lectures] = useState([])

  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return 
    }
    else {
      dialogHandler[1](false)
      if(callback) {
        callback()
      }
    }
  }

  const fetchSmst = async () => {
    const url = `/smst/last/any/${schola.id}`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.record)
  }

  const fetchSmsts = async () => {
    const url = `/smst/not/closed/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const fetchLecturesOld = async (smstId) => {
    const url = `/lecture/smst/${smstId}`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const fetchLectures = async (smstIdList) => {
    const url = `/lecture/smstids`
    openIndicator()
    const resp = await WebService.post(url, smstIdList)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }
  
  const onLoad =  async() => {
    /*
    const smst = await fetchSmst()
    if(smst) {
      set_smst(smst)
      const lectures = await fetchLectures(smst.id)
      if(lectures) {
        set_lectures(lectures)
      }
    }
    */
    const smstList = await fetchSmsts()
    console.log('smstList => ', smstList)
    if(smstList) {
      const idList = smstList.map(r => r.id)
      const lectures = await fetchLectures(idList)
      if(lectures) {
        for(const lecture of lectures) {
          const smst = smstList.find(r => r.id === lecture.smstId)
          lecture.gisu = smst?.gisu
          lecture.smstPhase = smst?.phase
        }
        lectures.sort((a,b) => a.smstPhase - b.smstPhase)
        console.log('lectures ====>', lectures)
        set_lectures(lectures)
      }
    }
  }

  const validate = async(name, value) => {
    let err = ''
    if(name === 'topicMenu') {
      if(!value) {
        err = '수신 그룹을 선택해 주세요.'
      }
      // else if(value === 'TP06') {
      //   if(!activeRow['lectureId']) {
      //     err = '강좌를 선택해 주세요.'
      //   }
      // }
    }
    if(name === 'title') {
      if(!value) {
        err = '제목이 비어 있습니다.'
      }

    }
    if(name === 'content') {
      if(!value) {
        err = '내용이 비어 있습니다.'
      }
    }
    return err
  }

  const canSubmit = async () => {
    if(factor.title.trim() === '') {
      alert('제목이 비어 있습니다')
      return false
    }
    if(factor.content.trim() === '') {
      alert('내용이 비어 있습니다')
      return false
    }
    if(factor.topicMenu === 'TP06') {
      if(!factor.lectureId) {
        alert('강좌정보가 비어 있습니다')
        return false
      }
    }
    await preSubmit()
    return true
  }

  const preSubmit = async() => {
    const topicCode = activeRow.topicMenu
    const url = encodeURI(`/sms/pre/fetch/${schola.id}/${topicCode}`)
    const params = {lectureId: activeRow.lectureId}
    const data = {
      title: activeRow.title,
      content: activeRow.content
    }

    openIndicator()
    const resp = await WebService.post(url, data, params)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage) 
    set_smsConfirm(`${repMessage.confirm}\n메시지를 발송하시겠습니까?`)
  }


  const onSubmit = async() => {
    openIndicator()
    const topicCode = activeRow.topicMenu
    const url = encodeURI(`/sms/${schola.id}/${topicCode}`)
    const params = {lectureId: activeRow.lectureId}
    const data = {
      title: activeRow.title,
      content: activeRow.content
    }
    const resp = await WebService.post(url, data, params)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      closeIndicator()
      return
    }
    alert('전송하였습니다.')
    closeIndicator()

    callback()
  }

  const {activeRow, errors, updateState, handleChange, handleSubmit, factor} = useDelegate({
    initialValues: { ...data },
    onSubmit: onSubmit,
    validate: validate,
  });

  useEffect(() => {
    if(dialogHandler[0]) {
      onLoad()
    }
  },[dialogHandler[0]])

  useEffect(() => {
    updateState()
  },[lectures])

  return (
    <Fragment>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='sm' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            문자 메시지 전송
          </Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          <br/>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id='topicMenu'>
                  수신그룹
                </InputLabel>
                <Select
                  labelId='topicMenu'
                  required
                  label='수신그룹'
                  name={"topicMenu"}
                  defaultValue={activeRow['topicMenu']}
                  onChange={async (e) => {
                    handleChange(e, () => updateState())
                  }}>
                  {topicMenu.map((l, index) => {
                    return (
                      <MenuItem key={index} value={l.value}>
                        {l.name}
                      </MenuItem>
                    )
                  })}
                </Select>

              </FormControl>
              <FormHelperTexts>{errors["topicMenu"]}</FormHelperTexts>
            </Grid>
            {
              activeRow['topicMenu'] === 'TP06' ? (
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id='lecture'>
                      강좌
                    </InputLabel>
                    <Select
                      labelId='topicMenu'
                      required
                      label='강좌'
                      name={"lectureId"}
                      defaultValue={activeRow['lectureId'].value}
                      onChange={async (e) => {
                        handleChange(e, () => updateState())
                      }}>
                      {lectures.map((l, index) => {
                        return (
                          <MenuItem key={index} value={l.id}>
                            {l.gisu} 기 / {l.title}
                          </MenuItem>
                        )
                      })}
                    </Select>

                  </FormControl>
                </Grid>
              ): null
            }

            <Grid item xs={12}>
              <TextField
                label={'제목'}
                fullWidth
                name={'title'}
                defaultValue={activeRow['title']}
                onChange={handleChange}
              />
              <FormHelperTexts>{errors["title"]}</FormHelperTexts>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={'내용'}
                fullWidth
                multiline
                rows={15}
                name={'content'}
                defaultValue={activeRow['content']}
                onChange={handleChange}
              />
              <FormHelperTexts>{errors["content"]}</FormHelperTexts>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions >
          <Button onClick={handleClose}>
            닫기
          </Button>
          <ConfirmDialog
            btn={<Button variant='contained' color={'primary'}>전송</Button>}
            title={'알림'}
            content={smsConfirm}
            bc={'primary'}
            preHandle={ async () => {
              return canSubmit()
            }}
            perform={() => {
              handleSubmit()
            }}
          />

        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default ManagerMessageSmsPartSend
